export default __webpack_public_path__ + "img/circle.32a03eb8.svg";